package ui.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import kotlinx.browser.window
import org.w3c.dom.events.Event
import org.w3c.dom.events.EventListener
import org.w3c.dom.url.URLSearchParams

@Composable
actual fun GreetingByPath(): String {

    // ambil query param "to"
    val currentName = remember {
        mutableStateOf(getGuestName())
    }

    // update kalau URL berubah (misalnya navigasi manual)
    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            currentName.value = getGuestName()
        }
        window.addEventListener("popstate", listener)

        onDispose {
            window.removeEventListener("popstate", listener)
        }
    }

    return currentName.value
}

// function untuk ambil parameter ?to=
private fun getGuestName(): String {
    val params = URLSearchParams(window.location.search)
    val name = params.get("to")

    return name
        ?.replace("+", " ")
        ?.let { js("decodeURIComponent(it)") as String }
        ?.ifBlank { "Nama Tamu" }
        ?: "Nama Tamu"
}